import { AlertTriangle } from "lucide-react";

interface StoreConnectionErrorProps {
  storeCode: string;
  storeName?: string;
  errorType?: "connection_timeout" | "network_unreachable" | "server_offline";
  onRetry?: () => void;
}

export const StoreConnectionError = ({
  storeCode,
  storeName,
}: StoreConnectionErrorProps) => {
  const storeLabel = storeName ? `${storeName} (${storeCode})` : storeCode;

  return (
    <div className="flex flex-col items-center justify-center gap-5 py-12 px-4">
      <div className="relative flex items-center justify-center">
        <div className="absolute inset-0 rounded-full bg-amber-100 animate-[pulse_2.5s_ease-in-out_infinite]" />
        <div className="relative flex items-center justify-center w-14 h-14 rounded-full bg-amber-50 border border-amber-200">
          <AlertTriangle className="h-6 w-6 text-amber-500" strokeWidth={2} />
        </div>
      </div>

      <h3 className="text-[15px] font-semibold text-gray-800">
        Loja fora de alcance
      </h3>

      <p className="text-[13px] text-gray-500 text-center max-w-sm leading-5">
        O banco de dados desta loja está indisponível no momento.
        Os dados dos operadores não puderam ser carregados.
      </p>

      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-50 border border-amber-200">
        <span className="relative flex h-2 w-2">
          <span className="animate-[ping_1.5s_ease-in-out_infinite] absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500" />
        </span>
        <span className="text-xs font-mono font-medium text-amber-700">
          Loja {storeLabel}
        </span>
        <span className="text-[10px] font-medium text-amber-600 uppercase tracking-wide">
          Offline
        </span>
      </div>

    </div>
  );
};

export default StoreConnectionError;
